// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__uQHbq","label":"Completed_label__34LY2"};